module.exports = __webpack_public_path__ + "static/img/main.ac6adc64.png";